import { csrfToken } from "@/lib/orderActions"

// Transport for the Request-extra-hours form (UPDA-74). Mirrors
// lib/sampleRequests.js — session-auth JSON over the cookie, never the
// JWT-only /api/v1 routes.
//
// `priceOutOfScope` carries the discount code alongside the hours because the
// server prices the two together: whether a code can be used at all depends on
// how many hours it is being applied to.

// A refusal may carry `finishProfile`, the page that unblocks it (Clear passage).
async function jsonResponse(response, fallback) {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw Object.assign(new Error(data.error || fallback), { finishProfile: data.finishProfile })
  return data
}

export async function loadOutOfScopeOptions(slug, { signal } = {}) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/out_of_scope`, {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    signal,
  })
  return jsonResponse(response, "We couldn't open that request.")
}

export async function priceOutOfScope(slug, { hours, code }, { signal } = {}) {
  const query = new URLSearchParams({ hours: String(hours ?? "") })
  if (code) query.set("code", code)

  const response = await fetch(
    `/freelancers/${encodeURIComponent(slug)}/out_of_scope/price?${query}`,
    { headers: { Accept: "application/json" }, credentials: "same-origin", signal }
  )
  return jsonResponse(response, "We couldn't price those hours.")
}

export async function sendOutOfScopeRequest(slug, outOfScope) {
  const response = await fetch(`/freelancers/${encodeURIComponent(slug)}/out_of_scope`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({ out_of_scope: outOfScope }),
  })
  return jsonResponse(response, "We couldn't send that request.")
}
